<template>
    <div class="form-group">
        <label for="name">{{ title }}:</label>
        <textarea class="form-control" :name="name" cols="10" rows="4" @input="handleInput" v-model="content"></textarea>
        <p class="text-center alert alert-danger" v-if="errors[name]">{{ errors[name][0] }}</p>
    </div>
</template>

<script>
    export default{
        name: 'vInput',
        props: {
            type: {
                default: 'text'
            },
            name:{
                default: ''
            },
            title: {
                default: ''
            },
            value: {
                default: ''
            }
        },  
        data(){
            return{
                content: this.value,
                errors: {}
            }
        },
        mounted() {
            this.$emit('input', this.value === null ? '' : this.value)
            Event.listen('errors', (e) => {
                this.errors = e
            })
        },
        watch: {
          value: function(newVal, oldVal) {
            this.content = newVal
          }
        },
        methods: {
            handleInput (e) {
                this.$emit('input', this.content)
                this.$delete(this.errors, this.name)
            }
        }
    };
</script>
